export default __webpack_public_path__ + "static/media/outages_current.07c639fb.svg";